import Link from 'next/link'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import pathConfiguration from 'src/configuration/path'
import IconWrapper from '~/core/ui/IconWrapper'

interface Props {
  className?: string
  label?: string
  link: string
}

const SeeMoreLink: FC<Props> = ({ className, label, link }) => {
  const { t, i18n } = useTranslation()

  return (
    <Link
      href={link || pathConfiguration.contactRequest}
      target="_blank"
      locale={i18n?.language}
      className={className}>
      <div className="flex items-center justify-center gap-1 text-primary-500 text-lg">
        {label || t('lp:see_more')}
        <IconWrapper
          size={18}
          name="ArrowUpRight"
          className="text-primary-500"
        />
      </div>
    </Link>
  )
}

export default SeeMoreLink
